import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import GateFrame from './GateFrame';
import { loadGate, toggleResetState } from "../../store/gateReducer/actions";

const FrameLayout = (props) => {
  useEffect(() => { 
    console.log("re-render frame layout.");
  }, [props.resetState]);

    return <div style={props.shouldDisplay ? {display: 'contents'} : {display: 'none'}}>
        <GateFrame {...props} />
    </div>
}

const mapStateToProps = ({ gateReducer }) => ({resetState: gateReducer.resetState});
    
  const mapDispatchToProps = {
    resetGateId: () => loadGate('', null),
    changeResetState: () => toggleResetState(),
  };
  
  export default 
    connect(mapStateToProps, mapDispatchToProps)
  (FrameLayout);
